export default __webpack_public_path__ + "static/media/tick-circle.8e64171d.svg";